/**
 * 扣款登记
 * Date         Version Remarks
 * @author FJJ
 * @version 1.0
 * ============ ======= ======================================================
 * 2022/11/03      1.0     First version  FJJ
 *
 * Copyright 2022, all rights reserved. Essa.cn
 * */


import React from 'react'
import {Alert, Button, } from "antd";
import Lang from "@components/Lang/Lang";
import Add from "./Add";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import AutoFetchTable from "@components/AutoFetchTable/AutoFetchTable";
import { Link } from "react-router-dom";
import {getColumns} from "../component/PaymentColumns";
import "./index.less";


class PaymentCheckOut extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            //加载中
            loading: true,
            // 列
            columns: getColumns(),
            isVisible:false,
        }
    }

    getData(){
        this.onRefTabChildOne.handleFetch(1,{},true)
    }
    onRefTabOne = (ref) =>  this.onRefTabChildOne = ref;
    componentDidMount() {
    }
    render(){
        const {columns} =  this.state;
        return (
            <div className="payment-check-in-wrap">
                <CommonBreadcrumb
                    list={[{ name:Lang({id: 'KouJianDengJi', default: '退款登记'}) }]}
                ></CommonBreadcrumb>

                <div className="main-wrap">
                    <span className="title fw_700 font-18">{Lang({id: 'TuiKuanDengJi', default: '扣减登记'})}</span>
                    <Alert
                        message={Lang({id:'GaiCaoZuoJiangKouJianKeHuDeYuE',default:'该操作将扣减客户的余额'})}
                        type="warning"
                        className={"mt_8"}
                    />
                    <Add callBack={this.getData.bind(this)}></Add>
                </div>
                    <div className="main-wrap">
                        <div className="title flex-title">
                            <span>{Lang({id: 'JinQiTuiKuan', default: '近期退款'})}</span>
                            <Link to={`/financeManagement/paymentCheckOut-record`}>
                                <Button danger shape="round">
                                    {Lang({id: 'SuoYouKouJianJiLu', default: '所有扣减记录'})}
                                </Button>
                            </Link>
                        </div>
                        {/*表格*/}
                        <AutoFetchTable columns={columns}
                                        onRef={this.onRefTabOne}
                                        scroll={{ x: 1200 }}
                                        pageSize={10}
                                        paginationFlag={false}
                                        fetchApi={'/service/mg/fin/ddp/deduction-item/list'}>
                        </AutoFetchTable>
                    </div>

            </div>
        )
    }
}
export default PaymentCheckOut;
